import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'

import { SharedUiMilitarySelectModule } from '../lib/shared-ui-military-select.module'
import { MilitarySelectDocsComponent } from './mlitary-select-docs/military-select-docs.component'
import { MilitarySelectExampleComponent } from './mlitary-select-docs/military-select-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiMilitarySelectModule
  ],
  declarations: [
    MilitarySelectDocsComponent,
    MilitarySelectExampleComponent
  ],
  exports: [
    MilitarySelectDocsComponent
  ]
})
export class SharedUiMilitarySelectDocsModule {}
